<template>
    <router-view></router-view>
</template>
<script>
export default {
    name: 'inner-Layout'
};
</script>
  